import React, { useState, useRef, useContext, useEffect } from "react";
import { EmploymentHistoryContext } from "context/EmploymentHistoryContext";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import get from "lodash/get";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import useUploadPreOnboardingDocs from "../../../../../src/hooks/useUploadPreOnboardingDocs";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import clsx from 'clsx';
import { useForm } from "react-hook-form";
import ValidateFile from "../../../../utils/ValidateFile";
import { toast } from "react-toastify";
import PropTypes from 'prop-types';

export default function EmploymentHistoryForm({
  index,
  errors,
  register,
  setValue,
  empHistoryDateRanges,
  setempHistoryDateRanges,
  empHistoryDatePickerRef,
  setDocError,
  docError,
}) {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    clearErrors,
    trigger,
  } = useForm();
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );

  const { handleFileUpload } = useUploadPreOnboardingDocs();
  const { employmentHistory } = getInvitedUserDetailsById;
  const savedData = employmentHistory;
  const { setEmploymentHistoryDetails } = useContext(EmploymentHistoryContext);
  const fileInputRefs = useRef({});
  const docs = useSelector((state) => state.getPreOnboardingDocsById.docs);
  const [pattern, setPattern] = useState({});
  const [customErrorForPattern, setCustomErrorForPattern] = useState({});
  const [empHistoryDoc, setEmpHistoryDoc] = useState({});
  const [
    customErrorForEmpHistoryDocUpload,
    setCustomErrorForEmpHistoryDocUpload,
  ] = useState({});
  const [
    successfulEmpHistoryFileUploadMsg,
    setSuccessfulEmpHistoryFileUploadMsg,
  ] = useState({});
  const [moreInputForRelievingLetter, setMoreInputForRelievingLetter] =
    useState(false);

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);

  useEffect(() => {
    empHistoryDatePickerRef.current = empHistoryDateRanges.map(
      (_, i) => empHistoryDatePickerRef.current[i] || React.createRef(),
    );
  }, [empHistoryDateRanges]);

  useEffect(() => {
    const initialRanges = savedData.map(item => [
      item.employmentPeriodFrom ? new Date(item.employmentPeriodFrom) : null,
      item.employmentPeriodTo ? new Date(item.employmentPeriodTo) : null
    ]);
    setempHistoryDateRanges(initialRanges);
    savedData?.map((_, index) => {
      setValue(
        `PrevEmpName[${index}]`,
        savedData[index].previousEmployerName ?? "",
      );
      setValue(`employeeCode[${index}]`, savedData[index].employeeCode ?? "");
      setValue(`telephoneNo[${index}]`, savedData[index].mobileNumber ?? "");
      setValue(`designation[${index}]`, savedData[index].designation ?? "");
      setValue(`department[${index}]`, savedData[index].department ?? "");
      setValue(
        `leaveReason[${index}]`,
        savedData[index].reasonForLeaving ?? "",
      );
      setValue(`managerName[${index}]`, savedData[index].managerName ?? "");
      setValue(
        `managerContactNo[${index}]`,
        savedData[index].managerContactNo ?? "",
      );
      setValue(`managerEmailId[${index}]`, savedData[index].managerEmail ?? "");
      setValue(`PrevEmpAddress[${index}]`, savedData[index].address ?? "");
      setValue(
        `empPeriodFrom[${index}]`,
        savedData[index].employmentPeriodFrom ? new Date(savedData[index].employmentPeriodFrom) : null,
      );
      setValue(
        `empPeriodTo[${index}]`,
        savedData[index].employmentPeriodTo ? new Date(savedData[index].employmentPeriodTo) : null,
      );
      setValue(`position[${index}]`, savedData[index].positionType ?? "");

      setValue(
        `expCertFile[${index}]`,
        savedData[index].experienceCertificateUrl ?? "",
      );
      setValue(
        `offerLetter[${index}]`,
        savedData[index].appointmentLetterUrl ?? "",
      );
    });
  }, [savedData, setValue]);

  useEffect(() => {
    employmentHistory.map(async (education, index) => {
      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `expCertFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `relievingLetterFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `offerLetter.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip1.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip2.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip3.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthBankStatement.${index}`,
          id: paramId,
        }),
      );
    });
  }, []);

  const handlePatternForPrevEmp = (e, patternRegex, field, index) => {
    let value = e.target.value;
    const fieldKey = `${field}[${index}]`;
    setPattern((prev) => ({ ...prev, [fieldKey]: value }));
    let patternErrorMessage = "";

    if (
      (field === "PrevEmpName" || field === "managerName") &&
      value &&
      !patternRegex.test(value)
    ) {
      patternErrorMessage = "No numbers or special characters are allowed";
    } else if (
      field === "managerContactNo" ||
      field === "officePhoneNo"
    ) {
      if (value.length > 10) {
        value = value.slice(0, 10);
        e.target.value = value;
      }
      if (value && !patternRegex.test(value)) {
        patternErrorMessage = "Only numbers are allowed";
      }
      else if (value && value.length < 10) {
        const fieldNames = {
          managerContactNo: "Manager contact number",
          officePhoneNo: "Office phone number"
        };

        const displayName = fieldNames[field] || "Contact number";

        patternErrorMessage = `${displayName} must be exactly 10 digits`;
      }
    } else if (field === "telephoneNo") {
      if (value && !patternRegex.test(value)) {
        console.log('=================================================================', value)
        patternErrorMessage = "Only numbers are allowed";
      }
    } else if (field === "employeeCode") {
      if (value.length > 10) {
        value = value.slice(0, 10);
        e.target.value = value;
      }
      if (value && !patternRegex.test(value)) {
        patternErrorMessage = "Only numbers are allowed";
      }
    } else if (field === "designation" || field === "department") {
      if (value && !patternRegex.test(value)) {
        patternErrorMessage = "Please write as per the correct format (Number not allowed)";
      }
    } else if (field === "managerEmailId") {
      if (value && !patternRegex.test(value)) {
        patternErrorMessage = "Please write the valid email address";
      }
    }
    setCustomErrorForPattern((prev) => ({
      ...prev,
      [fieldKey]: patternErrorMessage,
    }));
    if (patternErrorMessage === "") {
      clearErrors(fieldKey);
    }
  };
  const handleAdditionOfFiles = () => {
    setMoreInputForRelievingLetter(true);
  };
  const handleRemovalOfFiles = () => {
    setMoreInputForRelievingLetter(false);
  };

  const handleFileForDocs = (e, field) => {
    const file = e.target.files[0];
    const allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const validate = ValidateFile(file, allowedFileTypes)
    if (validate !== true) {
      toast.error(validate);
      return;
    }
    setCustomErrorForEmpHistoryDocUpload((prev) => ({ ...prev, [field]: "" }));
    setSuccessfulEmpHistoryFileUploadMsg((prev) => ({ ...prev, [field]: "" }));
    if (file) {
      const fileType = file.type;
      setEmpHistoryDoc((prevState) => ({
        ...prevState,
        [field]: file,
      }));
      clearErrors(field);
    }
  };

  const handleFileUploadEdu = async (e, field) => {
    const file = e.target.files[0];
    const allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const validate = ValidateFile(file, allowedFileTypes)
    if (validate !== true) {
      toast.error(validate);
      if (fileInputRefs.current[field]) {
        fileInputRefs.current[field].value = "";
      }
      setValue(field, null);
      return;
    }
    setCustomErrorForEmpHistoryDocUpload((prev) => ({ ...prev, [field]: "" }));
    setSuccessfulEmpHistoryFileUploadMsg((prev) => ({ ...prev, [field]: "" }));
    if (file) {
      const fileType = file.type;
      console.log('file type==', file.type);
      setEmpHistoryDoc((prevState) => ({
        ...prevState,
        [field]: file,
      }));
      clearErrors(field);
    }
    // const file = empHistoryDoc[field];
    if (!file) {
      setCustomErrorForEmpHistoryDocUpload((prev) => ({
        ...prev,
        [field]: "Please select a file to upload",
      }));
      return;
    }
    await handleFileUpload(file, field, paramId);
    dispatch(fetchgetPreOnboardingDocsById({ type: field, id: paramId }));
    setDocError((prev) => ({
      ...prev,
      [field]: false,
    }));
  };

  const handleInputChange = (field, index, value) => {
    setEmploymentHistoryDetails((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [index]: value,
      },
    }));
  };

  return (
    <div className="empHistoryContainer" key={index}>
      <div>
        <div className="empHistoryDetailHeading">
          <h6 className="empHeadline">EMPLOYMENT HISTORY</h6>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="empHistoryForm form-row">
        <div className="PrevEmpNameContainer col-md-12">
          <div className="form-group emp-name-container  col-md-6">
            <label htmlFor="prevEmpName">
              Previous Employer Name<span className="required">*</span>
            </label>
            <input id="prevEmpName" type="text"
              placeholder={get(errors, `PrevEmpName[${index}]`) ? "⚠ Employer Name is required" : "Previous Employer Name"}
              className={clsx("form-control PrevEmpNameInput", { "invalid": get(errors, `PrevEmpName[${index}]`) || customErrorForPattern[`PrevEmpName[${index}]`] })}
              {...register(`PrevEmpName[${index}]`, {
                required: true,
                minLength: { value: 3, message: "Name must be at least 3 characters", },
                maxLength: { value: 50, message: "Name cannot exceed 50 characters", },
              })}
              value={pattern[`PrevEmpName[${index}]`]}
              onChange={(e) => {
                const value = e.target.value;
                handlePatternForPrevEmp(e, /^[A-Za-z\s]+$/, "PrevEmpName", index,);
                handleInputChange("PrevEmpName", index, e.target.value);
                if (get(errors, `PrevEmpName[${index}]`)) {
                  clearErrors(`PrevEmpName[${index}]`);
                }
                setValue(`PrevEmpName[${index}]`, value, { shouldValidate: true, });
              }}
              onBlur={(e) => { setValue(`PrevEmpName[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`PrevEmpName[${index}]`] && (<div className="errorMessage">{customErrorForPattern[`PrevEmpName[${index}]`]}</div>)}
            {get(errors, `PrevEmpName[${index}]`) && (<div className="errorMessage">{get(errors, `PrevEmpName[${index}]`).message}</div>)}
          </div>

          <div className="emp-code-container form-group col-md-6">
            <label htmlFor="employeeCode">
              Employee Code<span className="required">*</span>
            </label>
            <input id="employeeCode" type="text"
              placeholder={get(errors, `employeeCode[${index}]`) ? "⚠ Employee Code is required" : "Employee Code"}
              className={clsx("form-control empCodeInput", { "invalid": get(errors, `employeeCode[${index}]`) || customErrorForPattern[`employeeCode[${index}]`] })}
              {...register(`employeeCode[${index}]`, {
                required: true,
                minLength: { value: 3, message: "Must be at least 3 characters", },
                maxLength: { value: 10, message: "Cannot exceed 10 characters", },
              })}
              onChange={(e) => {
                const value = e.target.value;
                handleInputChange("employeeCode", index, e.target.value);
                if (get(errors, `employeeCode[${index}]`)) {
                  clearErrors(`employeeCode[${index}]`);
                }
              }}
              onBlur={(e) => { setValue(`employeeCode[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`employeeCode[${index}]`] && (
              <div className="errorMessage">
                {customErrorForPattern[`employeeCode[${index}]`]}
              </div>
            )}
            {get(errors, `employeeCode[${index}]`) && (
              <div className="errorMessage">
                {" "}
                {get(errors, `employeeCode[${index}]`).message}
              </div>
            )}
          </div>
        </div>
        <div className="PrevEmpNameContainer col-md-12 mt-0">
          <div className="emp-mob-container form-group col-md-6">
            <label htmlFor="telephoneNo">Office Phone No.</label>
            <input
              id="telephoneNo"
              type="tel"
              placeholder="Office Phone No."
              className={clsx("form-control teleInput", { "invalid": errors?.[`telephoneNo[${index}]`] })}
              {...register(`telephoneNo[${index}]`, {
                pattern: {
                  value: /^[0-9]*$/,
                  message: "Only numbers are allowed",
                }
              })}
              value={pattern[`telephoneNo[${index}]`]}
              onChange={(e) => {
                handlePatternForPrevEmp(e, /^\d+$/, "telephoneNo", index);
                handleInputChange("telephoneNo", index, e.target.value);
              }}
            />
            {customErrorForPattern[`telephoneNo[${index}]`] ? (
              <div className="empErrorMessage">
                {customErrorForPattern[`telephoneNo[${index}]`]}
              </div>
            ) : (
              ""
            )}
            {errors[`telephoneNo[${index}]`] && (
              <div className="empErrorMessage">
                {errors[`telephoneNo[${index}]`].message}
              </div>
            )}
          </div>
          <div className="emp-desg-container form-group col-md-6">
            <label htmlFor="designation" >
              Designation<span className="required">*</span>
            </label>
            <input
              id="designation"
              type="text"
              placeholder={get(errors, `designation[${index}]`) ? "⚠ Designation is required" : "Designation"}
              className={clsx("form-control desgInput", { "invalid": get(errors, `designation[${index}]`) })}
              {...register(`designation[${index}]`, {
                required: true,
                maxLength: 50,
              })}
              value={pattern[`designation[${index}]`]}
              onChange={(e) => {
                const value = e.target.value;
                handlePatternForPrevEmp(
                  e,
                  /^[A-Za-z0-9-\s]+$/,
                  "designation",
                  index,
                );
                handleInputChange("designation", index, e.target.value);
              }}
              onBlur={(e) => { setValue(`designation[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`designation[${index}]`] ? (
              <div className="empErrorMessage">
                {customErrorForPattern[`designation[${index}]`]}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="PrevEmpNameContainer col-md-12 mt-0">
          <div className="emp-dep-container form-group col-md-6">
            <label htmlFor="department">Department</label>
            <input id="department" type="text"
              placeholder={get(errors, `department[${index}]`) ? "⚠ Department is required" : "Department"}
              className={clsx("form-control deptInput", { "invalid": errors?.[`department[${index}]`] })}
              {...register(`department[${index}]`, {
                maxLength: { value: 50, message: "Name cannot exceed 50 characters", },
                pattern: { value: /^[A-Za-z\s-]*$/, message: "Numbers are not allowed", },
              })}
              value={pattern[`department[${index}]`]}
              onChange={(e) => {
                handlePatternForPrevEmp(e, /^[A-Za-z\s]+$/, "department", index,);
                handleInputChange("department", index, e.target.value);
              }}
            />
            {customErrorForPattern[`department[${index}]`] ? (<div className="empHistoryErrorMessage">{customErrorForPattern[`department[${index}]`]}</div>) : ("")}

          </div>
          <div className="emp-leavereason-container form-group col-md-6">
            <label htmlFor="leaveReason">
              Reason for Leaving <span className="required">*</span>
            </label>
            <input id="leaveReason" type="text"
              placeholder={get(errors, `leaveReason[${index}]`) ? "⚠ Reason for Leaving is required" : "Reason for Leaving"}
              className={clsx("form-control leaveReasonInput", { "invalid": get(errors, `leaveReason[${index}]`) })}
              {...register(`leaveReason[${index}]`, {
                required: true,
                maxLength: { value: 100, message: "Name cannot exceed 100 characters", },
              })}
              value={pattern[`leaveReason[${index}]`]}
              onChange={(e) => {
                const value = e.target.value;
                handlePatternForPrevEmp(e, /^[A-Za-z\s]+$/, "leaveReason", index,);
                handleInputChange("leaveReason", index, e.target.value);
                setValue(`leaveReason[${index}]`, value, { shouldValidate: true, });
              }}
              onBlur={(e) => { setValue(`leaveReason[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`leaveReason[${index}]`] && (<div className="errorMessage">{customErrorForPattern[`leaveReason[${index}]`]}</div>)}
            {get(errors, `leaveReason[${index}]`) && (<div className="errorMessage">{get(errors, `leaveReason[${index}]`).message}</div>)}
          </div>
        </div>
        <div className="PrevEmpNameContainer col-md-12 mt-0">
          <div className="emp-manager-name-container form-group col-md-6">
            <label htmlFor="managerName">
              {"Manager's Name"}
            </label>
            <input
              id="managerName"
              type="text"
              placeholder={get(errors, `managerName[${index}]`) ? "⚠ Manager Name is required" : "Manager Name"}
              className={clsx("form-control managerNameInput", { "invalid": get(errors, `managerName[${index}]`) })}
              {...register(`managerName[${index}]`, {

                minLength: {
                  value: 3,
                  message: "Name must be at least 3 characters",
                },
                maxLength: {
                  value: 50,
                  message: "Name cannot exceed 50 characters",
                },
              })}
              value={pattern[`managerName[${index}]`]}
              onChange={(e) => {
                const value = e.target.value;
                handlePatternForPrevEmp(
                  e,
                  /^[A-Za-z\s]+$/,
                  "managerName",
                  index,
                );
                handleInputChange("managerName", index, e.target.value);
              }}
              onBlur={(e) => { setValue(`managerName[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`managerName[${index}]`] ? (
              <div className="empErrorMessage">
                {customErrorForPattern[`managerName[${index}]`]}
              </div>
            ) : (
              ""
            )}
            {errors[`managerName[${index}]`] && (
              <div className="empErrorMessage">
                {errors[`managerName[${index}]`].message}
              </div>
            )}
          </div>
          <div className="emp-manager-contact-container form-group col-md-6">
            <label htmlFor="managerContactNo">
              Manager Contact
            </label>
            <input
              id="managerContactNo"
              type="telephone"
              placeholder={get(errors, `managerContactNo[${index}]`) ? "⚠ Manager Contact is required" : "Mobile No."}
              className={clsx("form-control managerContactInput", { "invalid": get(errors, `managerContactNo[${index}]`) })}
              {...register(`managerContactNo[${index}]`, {

                minLength: {
                  value: 10,
                  message: "Contact no. must be of ten digits only",
                },
              })}
              value={pattern[`managerContactNo[${index}]`]}
              onChange={(e) => {
                const value = e.target.value;
                handlePatternForPrevEmp(
                  e,
                  /^\d+$/,
                  "managerContactNo",
                  index,
                );
                handleInputChange("managerContactNo", index, e.target.value);
              }}
              onBlur={(e) => { setValue(`managerContactNo[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`managerContactNo[${index}]`] ? (
              <div className="empHistoryErrorMessage">
                {customErrorForPattern[`managerContactNo[${index}]`]}
              </div>
            ) : (
              ""
            )}
            {errors[`managerContactNo[${index}]`] && (
              <div className="empErrorMessage">
                {errors[`managerContactNo[${index}]`].message}
              </div>
            )}
          </div>
        </div>
        <div className="PrevEmpNameContainer col-md-12 mt-0">
          <div className="emp-email-container form-group col-md-6">
            <label htmlFor="managerEmailId">
              Manager Email ID
            </label>
            <input
              id="managerEmailId"
              type="text"
              placeholder={get(errors, `managerEmailId[${index}]`) ? "⚠ Manager Email is required" : "Email ID"}
              className={clsx("form-control managerEmailInput", { "invalid": get(errors, `managerEmailId[${index}]`) })}
              {...register(`managerEmailId[${index}]`, {

              })}
              onChange={(e) => {
                const value = e.target.value;
                handleInputChange("managerEmailId", index, e.target.value);
                handlePatternForPrevEmp(
                  e,
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "managerEmailId",
                  index,
                );
              }}
              onBlur={(e) => { setValue(`managerEmailId[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
            {customErrorForPattern[`managerEmailId[${index}]`] ? (
              <div className="empHistoryErrorMessage">
                {customErrorForPattern[`managerEmailId[${index}]`]}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="emp-address-container form-group col-md-6">
            <label htmlFor="PrevEmpAddress">
              Office Address<span className="required">*</span>
            </label>
            <input
              id="PrevEmpAddress"
              type="text"
              placeholder={get(errors, `PrevEmpAddress[${index}]`) ? "⚠ Office Address is required" : "Previous Employer Address"}
              className={clsx("form-control PrevEmpAddressInput", { "invalid": get(errors, `PrevEmpAddress[${index}]`) })}
              {...register(`PrevEmpAddress[${index}]`, {
                required: true,
                maxLength: { value: 200, message: "Office Address cannot exceed 200 characters" }

              })}
              onChange={(e) => {
                const value = e.target.value;
                handleInputChange("PrevEmpAddress", index, e.target.value)
              }}
              onBlur={(e) => { setValue(`PrevEmpAddress[${index}]`, e.target.value, { shouldValidate: true, shouldTouch: true, }); }}
            />
          </div>
        </div>
        <div className="PrevEmpNameContainer col-md-12 mt-0">
          <div className="datepicker-container form-group col-md-6">
            <label >Employment Period</label>
            <DatePicker
              ref={(el) => (empHistoryDatePickerRef.current[index] = el)}
              selectsRange
              startDate={empHistoryDateRanges[index]?.[0] || null}
              endDate={empHistoryDateRanges[index]?.[1] || null}
              showMonthDropdown
              showYearDropdown
              onChange={(update) => {
                const newRanges = [...empHistoryDateRanges];
                newRanges[index] = update;
                setempHistoryDateRanges(newRanges);
                setValue(`empPeriodFrom[${index}]`, update[0]);
                setValue(`empPeriodTo[${index}]`, update[1]);
                trigger([`empPeriodFrom[${index}]`, `empPeriodTo[${index}]`]);
              }}
              maxDate={new Date()}
              placeholderText="Select Employment Period"
              className={clsx("form-control empFromInput", { "invalid": errors[`empPeriodFrom[${index}]`] || errors[`empPeriodTo[${index}]`] })}
              isClearable
            />
            <input type="hidden" {...register(`empPeriodFrom[${index}]`)} />
            <input type="hidden" {...register(`empPeriodTo[${index}]`)} />
            <img
              src={require("assets/img/calendar-icon.png")}
              alt="calendar"
              className="calendar-icon"
              onClick={() => {
                const picker = empHistoryDatePickerRef.current[index];
                if (picker) {
                  picker.setFocus?.() || picker.focus?.();
                }
              }
              }
            />
          </div>
        </div>
        <div className="PrevEmpNameContainer emp-position col-md-12 mt-0">
          <label>
            <span>Position<em className="required">*</em></span>
          </label>
          <label>
            <span>Permanent</span>
            <input
              type="radio"
              name="position"
              className="form-control radioCheck"
              {...register(`position[${index}]`, {
                required: true,
              })}
              value="permanent"
              onChange={(e) =>
                handleInputChange("position", index, e.target.value)
              }
            />
          </label>
          <label>
            <span>Temporary</span>
            <input
              type="radio"
              name="position"
              className="form-control radioCheck"
              {...register(`position[${index}]`, {
                required: true,
              })}
              value="temporary"
              onChange={(e) =>
                handleInputChange("position", index, e.target.value)
              }
            />
          </label>
          <label>
            <span>Contractual</span>
            <input
              type="radio"
              name="position"
              className="form-control radioCheck"
              {...register(`position[${index}]`, {
                required: true,
              })}
              value="contractual"
              onChange={(e) =>
                handleInputChange("position", index, e.target.value)
              }
            />
          </label>
        </div>
        {get(errors, `position[${index}]`) && (
          <div className="errorMessage">Please select the position type</div>
        )}
        <div className="PrevEmpNameContainer col-md-12 mt-3">
          <h6 className="prevDoc">
            Please submit a scan copy of your previous relevant documents -
          </h6><small className="help-text"><strong>Accepted Formats:</strong> PDF, JPEG, JPG, PNG only | Size: 10MB</small>
        </div>
        <div className="exp-file-Container">
          <label>Experience Certificate / Relieving Certificate<span className="required">*</span></label>
          <div className="exp-file-box">
            <div className="file-row">
              <div className="btn-slot">
                {!moreInputForRelievingLetter && (
                  <button
                    type="button"
                    className="form-control primary-btn"
                    onClick={handleAdditionOfFiles}
                    style={{
                      borderRadius: "0.25rem",
                      fontSize: "18px",
                      width: "27px",
                      height: "27px",
                      padding: "0",
                    }}
                  >
                    +
                  </button>
                )}
              </div>
              <input
                type="file"
                className={`form-control uploadFileOfExpCert ${errors?.[`expCertFile.${index}`] ? "invalid" : ""}`}
                {...register(`expCertFile.${index}`)}
                ref={(el) =>
                  (fileInputRefs.current[`expCertFile.${index}`] = el)
                }
                onChange={(e) => handleFileUploadEdu(e, `expCertFile.${index}`)}
              />
              {customErrorForEmpHistoryDocUpload[`expCertFile[${index}]`] && (
                <div className="docErrorMessage">
                  {customErrorForEmpHistoryDocUpload[`expCertFile[${index}]`]}
                </div>
              )}
              {successfulEmpHistoryFileUploadMsg[`expCertFile.${index}`] ? (
                <div className="docUploadSuccessMessage">
                  {successfulEmpHistoryFileUploadMsg[`expCertFile.${index}`]}
                </div>
              ) : (
                ""
              )}
              {docs[`expCertFile.${index}`] && (
                <a
                  href={docs[`expCertFile.${index}`]}
                  target="_blank"
                  rel="noreferrer"
                  title="View PDF"
                >
                  <span>View 📄</span>
                </a>
              )}
              {docError[`expCertFile.${index}`] && (
                <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                  document is required
                </div>
              )}
            </div>
            <div>
              {moreInputForRelievingLetter && (
                <>
                  <button
                    type="button"
                    className="primary-btn"
                    onClick={handleRemovalOfFiles}
                    style={{
                      borderRadius: "0.25rem",
                      fontSize: "18px",
                      width: "27px",
                      height: "27px",
                      padding: "0",
                    }}
                  >
                    -
                  </button>
                  <input
                    type="file"
                    className={`uploadFileOfExpCert ${errors?.[`relievingLetterFile.${index}`] ? "invalid" : ""}`}
                    {...register(`relievingLetterFile.${index}`)}
                    ref={(el) =>
                    (fileInputRefs.current[`relievingLetterFile.${index}`] =
                      el)
                    }
                    onChange={(e) =>
                      handleFileUploadEdu(e, `relievingLetterFile.${index}`)
                    }
                  />
                  {customErrorForEmpHistoryDocUpload[
                    `relievingLetterFile.${index}`
                  ] && (
                      <div className="docErrorMessage">
                        {
                          customErrorForEmpHistoryDocUpload[
                          `relievingLetterFile.${index}`
                          ]
                        }
                      </div>
                    )}
                  {successfulEmpHistoryFileUploadMsg[
                    `relievingLetterFile.${index}`
                  ] ? (
                    <div className="docUploadSuccessMessage">
                      {
                        successfulEmpHistoryFileUploadMsg[
                        `relievingLetterFile.${index}`
                        ]
                      }
                    </div>
                  ) : (
                    ""
                  )}
                  {docs[`relievingLetterFile.${index}`] && (
                    <a
                      href={docs[`relievingLetterFile.${index}`]}
                      target="_blank"
                      rel="noreferrer"
                      title="View PDF"
                    >
                      <span>View 📄</span>
                    </a>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="app-file-Container">
          <label htmlFor="offerLetter" className="relievingLabel">
            Appointment Letter / Offer Letter<span className="required">*</span>
          </label>
          <div className="exp-file-box">
            <div className="d-flex">
              <input
                id="offerLetter"
                type="file"
                className={`form-control uploadFileOfExpCert ${errors?.[`offerLetter.${index}`] ? "invalid" : ""}`}
                {...register(`offerLetter.${index}`)}
                ref={(el) =>
                  (fileInputRefs.current[`offerLetter.${index}`] = el)
                }
                onChange={(e) => handleFileUploadEdu(e, `offerLetter.${index}`)}
              />
              {customErrorForEmpHistoryDocUpload[`offerLetter[${index}]`] ? (
                <div className="docErrorMessage">
                  {customErrorForEmpHistoryDocUpload[`offerLetter[${index}]`]}
                </div>
              ) : (
                ""
              )}
              {successfulEmpHistoryFileUploadMsg[`offerLetter.${index}`] ? (
                <div className="docUploadSuccessMessage">
                  {successfulEmpHistoryFileUploadMsg[`offerLetter.${index}`]}
                </div>
              ) : (
                ""
              )}
              {docs[`offerLetter.${index}`] && (
                <a
                  href={docs[`offerLetter.${index}`]}
                  target="_blank"
                  rel="noreferrer"
                  title="View PDF"
                >
                  <span>View 📄</span>
                </a>
              )}
              {docError[`offerLetter.${index}`] && (
                <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                  document is required
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="salary-slip-container">
          <label>
            Last Three Month Salary Slip<span className="required">*</span>
          </label>
          <div className="salary-container">
            <div className="exp-file-box">
              <div className="d-flex">
                <input
                  type="file"
                  className={clsx("form-control uploadFileOfExpCert", { "invalid": errors[`lastThreeMonthSalarySlip1.${index}`] })}
                  {...register(`lastThreeMonthSalarySlip1.${index}`)}
                  ref={(el) =>
                  (fileInputRefs.current[
                    `lastThreeMonthSalarySlip1.${index}`
                  ] = el)
                  }
                  onChange={(e) =>
                    handleFileUploadEdu(e, `lastThreeMonthSalarySlip1.${index}`)
                  }
                />
                {customErrorForEmpHistoryDocUpload[
                  `lastThreeMonthSalarySlip1.${index}`
                ] ? (
                  <div className="docErrorMessage">
                    {
                      customErrorForEmpHistoryDocUpload[
                      `lastThreeMonthSalarySlip1.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {successfulEmpHistoryFileUploadMsg[
                  `lastThreeMonthSalarySlip1.${index}`
                ] ? (
                  <div className="docUploadSuccessMessage">
                    {
                      successfulEmpHistoryFileUploadMsg[
                      `lastThreeMonthSalarySlip1.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {docs[`lastThreeMonthSalarySlip1.${index}`] && (
                  <a
                    href={docs[`lastThreeMonthSalarySlip1.${index}`]}
                    target="_blank"
                    rel="noreferrer"
                    title="View PDF"
                  >
                    <span>View 📄</span>
                  </a>
                )}
                {docError[`lastThreeMonthSalarySlip1.${index}`] && (
                  <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                    document is required
                  </div>
                )}
              </div>
            </div>
            <div className="exp-file-box">
              <div className="d-flex">
                <input
                  type="file"
                  className={clsx("form-control uploadFileOfExpCert", { "invalid": errors[`lastThreeMonthSalarySlip2.${index}`] })}
                  {...register(`lastThreeMonthSalarySlip2.${index}`)}
                  ref={(el) =>
                  (fileInputRefs.current[
                    `lastThreeMonthSalarySlip2.${index}`
                  ] = el)
                  }
                  onChange={(e) =>
                    handleFileUploadEdu(e, `lastThreeMonthSalarySlip2.${index}`)
                  }
                />
                {customErrorForEmpHistoryDocUpload[
                  `lastThreeMonthSalarySlip2.${index}`
                ] ? (
                  <div className="docErrorMessage">
                    {
                      customErrorForEmpHistoryDocUpload[
                      `lastThreeMonthSalarySlip2.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {successfulEmpHistoryFileUploadMsg[
                  `lastThreeMonthSalarySlip2.${index}`
                ] ? (
                  <div className="docUploadSuccessMessage">
                    {
                      successfulEmpHistoryFileUploadMsg[
                      `lastThreeMonthSalarySlip2.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {docs[`lastThreeMonthSalarySlip2.${index}`] && (
                  <a
                    href={docs[`lastThreeMonthSalarySlip2.${index}`]}
                    target="_blank"
                    rel="noreferrer"
                    title="View PDF"
                  >
                    <span>View 📄</span>
                  </a>
                )}

                {docError[`lastThreeMonthSalarySlip2.${index}`] && (
                  <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                    document is required
                  </div>
                )}
              </div>
            </div>
            <div className="exp-file-box">
              <div className="d-flex">
                <input
                  type="file"
                  className={clsx("form-control uploadFileOfExpCert", { "invalid": errors[`lastThreeMonthSalarySlip3.${index}`] })}
                  {...register(`lastThreeMonthSalarySlip3.${index}`)}
                  ref={(el) =>
                  (fileInputRefs.current[
                    `lastThreeMonthSalarySlip3.${index}`
                  ] = el)
                  }
                  onChange={(e) =>
                    handleFileUploadEdu(e, `lastThreeMonthSalarySlip3.${index}`)
                  }
                />
                {customErrorForEmpHistoryDocUpload[
                  `lastThreeMonthSalarySlip3.${index}`
                ] ? (
                  <div className="docErrorMessage">
                    {
                      customErrorForEmpHistoryDocUpload[
                      `lastThreeMonthSalarySlip3.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {successfulEmpHistoryFileUploadMsg[
                  `lastThreeMonthSalarySlip3.${index}`
                ] ? (
                  <div className="docUploadSuccessMessage">
                    {
                      successfulEmpHistoryFileUploadMsg[
                      `lastThreeMonthSalarySlip3.${index}`
                      ]
                    }
                  </div>
                ) : (
                  ""
                )}
                {docs[`lastThreeMonthSalarySlip3.${index}`] && (
                  <a
                    href={docs[`lastThreeMonthSalarySlip3.${index}`]}
                    target="_blank"
                    rel="noreferrer"
                    title="View PDF"
                  >
                    <span>View 📄</span>
                  </a>
                )}

                {docError[`lastThreeMonthSalarySlip3.${index}`] && (
                  <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                    document is required
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="bank-details-container">
          <label>
            Last Three Month Bank Statements<span className="required">*</span>
          </label>
          <div className="exp-file-box">
            <div className="d-flex">
              <input
                type="file"
                className={clsx("form-control uploadFileOfExpCert", { "invalid": errors[`lastThreeMonthBankStatement.${index}`] })}
                {...register(`lastThreeMonthBankStatement.${index}`)}
                ref={(el) =>
                (fileInputRefs.current[
                  `lastThreeMonthBankStatement.${index}`
                ] = el)
                }
                onChange={(e) =>
                  handleFileUploadEdu(e, `lastThreeMonthBankStatement.${index}`)
                }
              />
              {customErrorForEmpHistoryDocUpload[
                `lastThreeMonthBankStatement.${index}`
              ] ? (
                <div className="docErrorMessage">
                  {
                    customErrorForEmpHistoryDocUpload[
                    `lastThreeMonthBankStatement.${index}`
                    ]
                  }
                </div>
              ) : (
                ""
              )}
              {successfulEmpHistoryFileUploadMsg[
                `lastThreeMonthBankStatement.${index}`
              ] ? (
                <div className="docUploadSuccessMessage">
                  {
                    successfulEmpHistoryFileUploadMsg[
                    `lastThreeMonthBankStatement.${index}`
                    ]
                  }
                </div>
              ) : (
                ""
              )}
              {docs[`lastThreeMonthBankStatement.${index}`] && (
                <a
                  href={docs[`lastThreeMonthBankStatement.${index}`]}
                  target="_blank"
                  rel="noreferrer"
                  title="View PDF"
                >
                  <span>View 📄</span>
                </a>
              )}
              {docError[`lastThreeMonthBankStatement.${index}`] && (
                <div className="errorMessage text-center w-full text-red-500 text-sm mt-1">
                  Document is required
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

EmploymentHistoryForm.propTypes = {
  index: PropTypes.number.isRequired,
  empHistoryDateRanges: PropTypes.array.isRequired,
  setempHistoryDateRanges: PropTypes.func.isRequired,

  empHistoryDatePickerRef: PropTypes.shape({
    current: PropTypes.any
  }).isRequired,
  docError: PropTypes.object,
  setDocError: PropTypes.func.isRequired,

  paramId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setSignError: PropTypes.func.isRequired,
};
